<form
  class="leading-3"
  [formGroup]="formGroup"
>
  <p-toggleswitch
    ariaLabel="Dark Mode Toggle"
    formControlName="darkMode"
  >
    <ng-template
      #handle
      let-checked="checked"
    >
      <i [ngClass]="['!text-xs', 'pi', checked ? 'pi-moon' : 'pi-sun']"></i>
    </ng-template>
  </p-toggleswitch>
</form>
